( function( $ ) {
    $(".wpg-wdp-product-list-item").on( "click", function() {
        //trigger is not working for clickable div but needed for meetplan
        $(this).off('click').find('.wpg-wdp-product-list-item-title-link').trigger('click'); //too much recursion
        window.location = $(this).find(".wpg-wdp-product-list-item-title-link").attr("href"); 
    });
} )( jQuery );
